import axios from "axios";
import { BASE_URL, ENDPOINTS } from "../utils/endpoints";
import { toast } from "react-toastify";
import useAuthStore from "../store/authStore";

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Request interceptor: attach access token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: refresh token if 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Prevent infinite loop on refresh endpoint
      if (originalRequest.url === ENDPOINTS.REFRESH_TOKEN) {
        handleSessionExpired();
        return Promise.resolve({ data: error, status: 401, suppressed: true });
      }

      try {
        const { data } = await api.post(
          ENDPOINTS.REFRESH_TOKEN,
          {}
        );
        if (data.success) {
          localStorage.setItem("accessToken", data.accessToken);
          originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
          return api(originalRequest); // retry original request
        } else {
          handleSessionExpired();
        }
      } catch (err) {
        handleSessionExpired();
      }
    }

    return Promise.reject(error);
  }
);

export default api;

export const handleSessionExpired = () => {
  const { logout } = useAuthStore.getState();
  toast.error("Session Time Out. Please Login Again");
  logout();
  window.location.href = "/";
};
